module.exports = __webpack_public_path__ + "img/littlt4.8431090c.webp";